import React from 'react';

const FirstStep = ({ children }) => (
  <div
    className="bg-cover bg-center bg-enterpriseOrange-800 bg-opacity-100 bg-first-step-mic-xs pl-6 md:bg-first-step-mic-md md:pl-36 lg:bg-first-step-mic-lg lg:pl-44.5 2xl:bg-first-step-mic-2xl 2xl:pl-68 3xl:bg-first-step-mic-3xl 3xl:pl-80 h-80 md:h-52 lg:h-64 2xl:h-92 3xl:h-120 w-full"
    style={{ backgroundBlendMode: 'soft-light' }}
  >
    <h2 className="font-montserrat text-white text-left font-bold mt-24 text-3xl w-70 md:mt-9 md:h-20 md:w-60 lg:mt-12 lg:text-5xl lg:h-28 lg:w-94 lg:leading-15 2xl:mt-16 2xl:h-36 2xl:w-116 2xl:text-6xl 2xl:leading-18.25 3xl:mt-24 3xl:h-48 3xl:w-154 3xl:text-7xl 3xl:leading-24.5">
      Ready to take that first step?
    </h2>
    <div className="mt-6 md:mt-4 lg:mt-5 2xl:mt-8 3xl:mt-11">{children}</div>
  </div>
);

export default FirstStep;
